export const addSentryEventUrl = (event: { request?: object }, url: string): void => {
  event.request = { ...event.request, url };
};

export const removeSentryRouteTags = (event: { tags?: unknown }): void => {
  if (!event.tags || typeof event.tags !== "object") {
    return;
  }

  const tags = event.tags as Record<string, unknown>;
  delete tags.hotelId;
  delete tags.checkoutId;
  delete tags.dealKey;
  delete tags.routeTemplate;
};
